import { catchError, filter, map, switchMap } from 'rxjs/operators'
import { isActionOf } from 'typesafe-actions'
import { from, of } from 'rxjs'
import { toast } from 'react-toastify'
import { getTransactionDetailsFailure, getTransactionDetailsRequest, getTransactionDetailsSuccess } from '../actions'
import { RootEpic } from '../types'

export const getTransactionDetailsEpic: RootEpic = (action$, state$, { getTransactionDetails }) =>
  action$.pipe(
    filter(isActionOf([getTransactionDetailsRequest])),
    switchMap(({ payload }) =>
      from(
        getTransactionDetails({
          token: state$.value.app.authToken as string,
          ...payload,
        }),
      ).pipe(
        map((response) => getTransactionDetailsSuccess(response)),
        catchError((message) => {
          toast.error('Failed to fetch transaction detail.')
          return of(getTransactionDetailsFailure(message))
        }),
      ),
    ),
  )

export default [getTransactionDetailsEpic]
